//GeneratorFlag:[NoChange]
<template>
	<div>kaveh.app.toolbar.store.notification</div>
</template>